module.exports = __webpack_public_path__ + "static/media/Team 42 - Our Place.3af397ee.png";